import * as Synonym from 'types/Ingredient/Detail/Synonym';

export type Type = {
	[key: string]: Synonym.Type[];
};

export function create(): Type {
	return {};
}
